import React, { useState } from 'react';
import { Box, Typography, Paper, Stack, TextField, Button, Alert } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../theme';

export default function RoleSelectScreen({ onSelect }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || 'Anmeldung fehlgeschlagen.'); setLoading(false); return; }
      onSelect(data);
    } catch { setError('Netzwerkfehler. Bitte erneut versuchen.'); setLoading(false); }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Box sx={{ height: 100, mb: 1.5 }}>
            <img src="/logo.svg" alt="UWR" style={{ height: '100%', display: 'block' }} />
          </Box>
          <Typography variant="h4" fontWeight={800} color="primary">UWR Manager</Typography>
        </Box>
        <Paper elevation={2} sx={{ p: 4, width: '100%', maxWidth: 400, borderRadius: 3 }}>
          <Typography variant="h6" fontWeight={700} mb={3} textAlign="center">Anmelden</Typography>
          <form onSubmit={handleLogin}>
            <Stack spacing={2}>
              <TextField label="E-Mail" type="email" value={email} onChange={e => setEmail(e.target.value)}
                fullWidth autoComplete="email" required />
              <TextField label="Passwort" type="password" value={password} onChange={e => setPassword(e.target.value)}
                fullWidth autoComplete="current-password" required />
              {error && <Alert severity="error">{error}</Alert>}
              <Button type="submit" variant="contained" size="large" disabled={loading} fullWidth>
                {loading ? 'Anmelden…' : 'Anmelden'}
              </Button>
            </Stack>
          </form>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
